import React from "react";

/**
 * Real gold floral wreath monogram — served from /media/logo.png.
 * The `stroke` prop is retained for backwards compatibility but is no longer used.
 */
export const Monogram = ({ className = "h-9 w-9" }) => (
  <img
    src="/media/logo.png"
    alt="Anjola & Michael"
    className={`${className} object-contain`}
    data-testid="am-monogram"
    loading="eager"
    decoding="async"
  />
);

export default Monogram;
